<template>
    <div>
        <div class="d-flex justify-content-between mb-2 align-items-center flex-md-row flex-column">
            <div class="d-flex align-items-center mb-md-0 mb-2">
                <home-date-picker
                    @dates-changed="datesChanged"
                    :from-date="fromDate"
                    :to-date="toDate"
                    :date-range="dateRange"
                ></home-date-picker>
                <strong class="mx-2">vs</strong>
                <home-date-picker
                    @dates-changed="comparisonDatesChanged"
                    :from-date="comparisonFromDate"
                    :to-date="comparisonToDate"
                    :date-range="comparisonDateRange"
                ></home-date-picker>
            </div>
            <div v-if="option">
                <label class="label mb-0 mr-2" for="year"
                    ><strong>{{ optionField.title }}: </strong>
                    <span
                        @click="cancelOption"
                        class="badge badge-primary cursor-pointer"
                        >{{ option.value }} <i class="fa fa-times"></i></span
                ></label>
            </div>
        <div class ="mb-md-0 mb-2">
            <div v-if="surveys">
                <label class="label mb-0 mr-2" for="survey"
                    ><strong>{{ __('Survey') }}</strong></label
                >
                <select id="survey" v-model="selectedSurvey">
                    <option
                        :value="survey"
                        v-for="survey in surveys"
                        :key="survey.id"
                        >{{ survey.title }}</option
                    >
                </select>
            </div>
        </div>
            <div>
                <div class="dropdown dropdown-btn dropdown-btn-md-default dropdown-btn-large square ">
                    <div class="dropdown-select" data-toggle="dropdown">
                        <span>{{ __('Actions') }}</span>
                    </div>

                    <div class="dropdown-menu w-100" v-if="selectedSurvey">
                        <a
                            class="dropdown-item blue-link"
                            :href="'/surveys/' + selectedSurvey.id + '/import'"
                            ><i class="far fa-file-alt"></i> {{ __('Import Stats') }}</a
                        >
                        <a
                            class="dropdown-item blue-link"
                            :href="exportLink"
                            ><i class="far fa-file-alt"></i> {{ __('Export Stats') }}</a
                        >
                    </div>
                </div>
            </div>
        </div>
        <div>
            <survey-stats-view
                @option-filtered="setOptionFilter"
                :answerId="option ? option.optionId : null"
                :stats="stats"
                :fromDate="fromDate"
                :toDate="toDate"
                :comparisonFromDate="comparisonFromDate"
                :comparisonToDate="comparisonToDate"
                :survey="selectedSurvey"
            />
        </div>
    </div>

</template>

<script>
import ElementSelector from "../instagram/components/ElementSelector.vue";
import RecentYearsMixin from "../../mixins/RecentYearsMixin";
import SurveysService from "../../services/surveys-service";
import SurveyStatsView from "./SurveyStatsView";
import moment from "moment";
export default {
    mixins: [RecentYearsMixin],
    components: {
        ElementSelector,
        SurveyStatsView,
    },
    computed: {
        exportLink() {
            const append = '?token=' + Spark.jwtToken + '&fromDate=' + this.fromDate.format('YYYY-MM-DD')
                + '&toDate=' + this.toDate.format('YYYY-MM-DD')
                + '&comparisonFromDate=' + this.comparisonFromDate.format('YYYY-MM-DD')
                + '&comparisonToDate=' + this.comparisonToDate.format('YYYY-MM-DD')
            return `/surveys/${Spark.state.currentTeam.id}/${this.selectedSurvey.id}/stats/export${append}`;
        }
    },
    data() {
        return {
            surveys: null,
            selectedSurvey: null,
            stats: null,
            option: null,
            optionField: null,
            fromDate: moment().startOf("year"),
            toDate: moment(),
            dateRange: __('Year To Date'),
            comparisonDateRange: "Previous Year",
            comparisonFromDate: moment().startOf('year').subtract(1, 'year'),
            comparisonToDate: moment().subtract(1, 'year'),
            showAllSentiment: false,
        };
    },
    mounted() {
        this.getSurveys();
        this.$eventHub.$on("selectStatsSurvey", survey => {
            this.selectedSurvey = survey;
        });
    },
    methods: {
        async getSurveys() {
            const surveys = await SurveysService.index();
            this.surveys = surveys.data;
            this.selectedSurvey =
                this.surveys.length > 0 ? this.surveys[0] : null;
        },
        setOptionFilter(option, field) {
            this.option = option;
            this.optionField = field;
        },
        cancelOption() {
            this.option = null;
            this.optionField = null;
        },
        datesChanged(fromDate, toDate) {
            this.fromDate = moment(fromDate);
            this.toDate = moment(toDate);
            this.dateRange =
                this.fromDate.format("D MMM YYYY") +
                " - " +
                this.toDate.format("D MMM YYYY");
        },
        comparisonDatesChanged(fromDate, toDate) {
            this.comparisonFromDate = moment(fromDate);
            this.comparisonToDate = moment(toDate);
            this.comparisonDateRange =
                this.comparisonFromDate.format("D MMM YYYY") +
                " - " +
                this.comparisonToDate.format("D MMM YYYY");
        }
    }
};
</script>
